var map = {
	"./collage-0.avif": 91501,
	"./collage-1.avif": 5525,
	"./collage-1029w-0.avif": 33046,
	"./collage-2.avif": 40724,
	"./collage-3.avif": 93275,
	"./collage-4.avif": 51656,
	"./collage-503w-2.avif": 31298,
	"./collage-503w-4.avif": 55559
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66935;